import React from 'react';
import ServiceDetailPage from './ServiceDetailPage';
export default function OutdoorLivingMiami() {
  return <ServiceDetailPage slug="outdoor-living-miami" />;
}
